import { object, string } from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';

const validationSchema = object().shape({
  quickNotes: string().max(500, 'Max length - 500 symbols'),
});

export default yupResolver(validationSchema);
